import React from 'react';
import Svg, { Rect } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Drawer({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Rect x="3" y="11" width="18" height="2" fill={iconColor} />
      <Rect x="3" y="6" width="18" height="2" fill={iconColor} />
      <Rect x="3" y="16" width="18" height="2" fill={iconColor} />
    </Svg>
  );
}
